import Icon, { GenericIconProps } from '../Icon';

const PeopleIcon: React.FC<GenericIconProps> = ({ className }) => {
  const svg = {
    viewBox: '0 0 20 14',
  };

  const path = [
    {
      // eslint-disable-next-line max-len
      d: 'M16.6612 3.74683C16.6612 5.63205 15.133 7.16032 13.2478 7.16032C11.3625 7.16032 9.83427 5.63205 9.83427 3.74683C9.83427 1.86161 11.3625 0.333344 13.2478 0.333344C15.133 0.333344 16.6612 1.86161 16.6612 3.74683ZM8.90305 4.36756C8.90305 5.90988 7.65276 7.16018 6.11044 7.16018C4.56812 7.16018 3.31783 5.90988 3.31783 4.36756C3.31783 2.82525 4.56812 1.57495 6.11044 1.57495C7.65276 1.57495 8.90305 2.82525 8.90305 4.36756ZM6.06308 7.98756C7.1599 8.00328 8.23903 8.26631 9.22006 8.75706C8.55052 9.07613 7.94854 9.52092 7.44689 10.0672C6.9222 10.6329 6.62152 11.3703 6.60108 12.1416V12.7599H0.833008V11.1445C0.833008 9.03988 4.35304 7.98756 6.06308 7.98756ZM13.2965 8.44949C11.2944 8.44949 7.29691 9.68599 7.29691 12.1419V13.9834H19.2961V12.1419C19.2961 9.68599 15.2986 8.44949 13.2965 8.44949Z',
    },
  ];

  return <Icon className={className} svg={svg} path={path} />;
};

export default PeopleIcon;
